export default __webpack_public_path__ + "static/tl-96fc4c66cf855c1ce3c9b369f5525e60.svg";